import { getRequest, putRequest } from "./requestTemplates";
import type { Report } from "../Interfaces/TableInterfaces";
import { getTable } from "./requestTemplates";
import type {
  IMarketTradeHourSearchParams,
  IMarketTradeHourTableReport,
  IMarketTradeHourDto,
  IEditMarketTradeHourDto,
} from "src/Interfaces/marketTradeHour";
import type { Packet } from "src/Interfaces/commonDtos";

export const getMarketTradeHourTable = (
  searchParam: IMarketTradeHourSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IMarketTradeHourTableReport>> =>
  getTable<IMarketTradeHourSearchParams, IMarketTradeHourTableReport>(
    "/v1/TradeHour/marketTradeHoursTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getAllMarketTradeHours = (): Promise<IMarketTradeHourDto[]> =>
  getRequest("/v1/TradeHour/marketTradeHours");

export const getMarketTradeHourByType = (
  marketTradeHoursTypeId: number,
): Promise<IMarketTradeHourDto> =>
  getRequest(
    `/v1/TradeHour/marketTradeHour?marketTradeHoursTypeId=${marketTradeHoursTypeId}`,
  );

export const editMarketTradeHour = (
  body: IEditMarketTradeHourDto,
): Promise<Packet<boolean>> => putRequest("/v1/TradeHour/marketTradeHour", body);
